import Vue from 'vue'
import axios from 'axios';
function checkPower(str) {
    if (Vue.POWER.indexOf(str) > -1) {
        return true;
    } else {
        return false;
    }
}
function getListDev(callback) {
    axios.get('http://api.monitor.hzjly.cn/Dev/ListDev', {
        params: {}
    })
        .then(function (response) {
            if (response.data.status == 101) {
            } else {
                var data = JSON.parse(response.data);
                if (data.results.rows) {
                    callback(data.results.rows);
                } else {
                    this.$message({
                        message: data.results.data,
                        type: 'warning'
                    });
                    callback(data.results.rows);
                }
            }

        })
        .catch(function (error) {
            callback(error);
        });
}
export {
    checkPower,
    getListDev,

}
